import { ResumeData } from '../../components/resume/resume-page'
import profileImage from '../profile.jpg'

export const resume: Pick<ResumeData, 'introduction' | 'contacts'> = {
  introduction: {
    name: 'Sascha Eisenmann',
    jobTitle: 'Engineer / Architect',
    description:
      'Experienced software engineer and architect with a passion for business processes and problem-solving. I combine deep backend and frontend expertise with a DevOps mindset to deliver solutions that actually serve the business.',
    imageSrc: profileImage,
  },
  contacts: {
    email: 'consulting@eisenmann.it',
    phone: '+49 162 3092194',
  },
}
